import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import localstorage from 'src/helper/localstorage'
import { history } from 'src/core/router'
import { transformTime, transformTimeDate } from 'src/helper/tool'
import config from 'src/core/config'
export default class {
  // 翻页数据
  @observable listData = {
    loading: false,
    count: 0,
    list: [],
    size: 0,
    page: 0
  }
  // 单条数据
  @observable item = {}
  // 表单 动态操作 实时修改
  @observable form = { method: '', data: {}, modal: false, submit: false }
  // 整齐表单结构 只能实例化一次
  @observable op = {}
  // kv 结构
  @observable kv = new Map()
  // select Row 选择的行数
  @observable selectRow = []
  // 搜索条件 包含 page pageSize
  @observable searchMap = {}
  constructor(name) {
    this.url = name
  }
  _resetOp() {
    // 重置搜索条件
    this.searchMap = { page: 1, size: 50 }
    return {
      search: [],
      columns: [],
      // 修改 删除 操作
      columnsAction: [],
      // action: [{ name: '刷新', fn: this.get.bind(this), icon: 'sync' }],
      action: [],
      edit: [],
      // method 非restful 接口专用
      method: {
        get: false,
        post: false,
        put: false,
        del: false
      }
    }
  }
  @action onSelectChange(d) {
    this.selectRow = d
    console.log(JSON.stringify(this.selectRow))
  }
  @action setForm(o = {}) {
    this.form = Object.assign(this.form, o || {})
  }
  @action openModalForm(o = {}) {
    // console.log(7777777, this.form, o)
    o.modal = true
    this.form = Object.assign(this.form, o || {})
  }
  /**
   * 设置options
   * @param {*} name key
   * @param {*} value 赋值
   * @param {*} include 包含初始值
   */
  @action setOp(o) {
    let op = this._resetOp()
    for (let i in o) {
      if (Array.isArray(op[i])) {
        op[i] = op[i].concat(o[i])
      } else if (typeof op[i] === 'object') {
        op[i] = Object.assign(op[i], o[i])
      } else {
        op[i] = o[i]
      }
    }
    this.op = op
  }
  _setBizId(map) {
    // if (appId && !map.bizId) {
    // map.bizId = appId
    // }
    return map
  }
  @action async upload(map, cb) {
    return http.upload(map, cb)
  }
  /**
 * 设置搜索条件
 * @param {*} map 设置条件参数
 * @param {*} rewrite 重写搜索条件
 */
  @action searchSet(map = {}, rewrite = false) {
    let params = {}
    for (let k in map) {
      if (map[k] || map[k] === 0) {
        params[k] = map[k]
      }
    }
    /**
     * bizId 实例id 定制业务
     */
    this._setBizId(params)
    /**
     * 适应api 的hark cord
     */
    params.size = params.size || this.searchMap.size || 50
    params.page = params.page || this.searchMap.page || 1
    /**
     * 通用数据
     */
    // 重写search map条件    
    if (rewrite) {
      params.size = this.searchMap.size
      params.page = 1
      this.searchMap = params
    } else {
      this.searchMap = Object.assign(toJS(this.searchMap), params)
    }
    return toJS(this.searchMap)
  }
  @action async get(map = {}) {
    let pathname = window.location.pathname
    this.selectRow = []
    map = this.searchSet(map)
    // console.log("map", map)
    /**
     * 获取api
     */
    this.listData.loading = true

    console.log("这里用于统一处理提交的get数据",map)
    let fn = this.op.method.get ? this.op.method.get : http.get
    let d = await fn(this.url, map)

    console.log('列表页返回数据',d)

    if (!d) {
      d = {
        code: 0,
        count: 0,
        res: []
      }
    }

    if (d.code == 999) {
      //登录失败
      localstorage.remove('userToken')
      history.push('/oauth/login/index')
    }
    

    const res = (d && d.data && d.data.items) || []
    const count = (d && d.data && d.data.total !== undefined && d.data.total !== null)
      ? d.data.total
      : (res.length || 0)

    
    //默认一个id 作为index
    if (res && res.length > 0 && !res[0].id) {
      for (let index = 0; index < res.length; index++) {
        res[index].diyid = index + 1
      }
    }
    //特殊页协议处理
    if (pathname == '/dashboard/gift/list') {     
    }


    this.listData.list = res
    this.listData.count = count
    this.listData.page = map.page
    this.listData.pageSize = map.pageSize
    this.listData.loading = false
  }
  @action async clearNew(map = {}) {
    let pathname = window.location.pathname
    this.selectRow = []
    // console.log("map", map)
    /**
     * 获取api
     */
    this.listData.loading = true

    console.log("这里用于统一处理提交的get数据",map)
    let fn = this.op.method.get ? this.op.method.get : http.get
    let d = await fn(this.url, map)

    console.log('列表页返回数据',d)

    if (!d) {
      d = {
        code: 0,
        count: 0,
        res: []
      }
    }

    if (d.code == 999) {
      //登录失败
      localstorage.remove('userToken')
      history.push('/oauth/login/index')
    }
    

    const res = (d && d.data && d.data.items) || []
    const count = (d && d.data && d.data.total !== undefined && d.data.total !== null)
      ? d.data.total
      : (res.length || 0)

    
    //默认一个id 作为index
    if (res && res.length > 0 && !res[0].id) {
      for (let index = 0; index < res.length; index++) {
        res[index].diyid = index + 1
      }
    }
    //特殊页协议处理
    if (pathname == '/dashboard/gift/list') {     
    }


    this.listData.list = res
    this.listData.count = count
    this.listData.page = map.page
    this.listData.pageSize = map.pageSize
    this.listData.loading = false
  }
  @observable onSubmit = false
  @action async setSubmit(status) {
    this.onSubmit = status || false
  }

  @action async getOne(map = {}) {
    this._setBizId(map)
    this.item = await http.get(this.url, map)
  }
  @action async post(map = {}) {
    this._setBizId(map)
    let fn = this.op.method.post ? this.op.method.post : http.get
    let d = await fn(this.url, map)
    return d
  }
  @action async put(map = {}) {
    this._setBizId(map)
    let fn = this.op.method.put ? this.op.method.put : http.get
    let d = await fn(this.url, map)
    return d
  }
  @action async del(map = {}) {
    this._setBizId(map)
    let fn = this.op.method.del ? this.op.method.del : http.delete
    let d = await fn(this.url, map)
    return d
  }

  /**
   * 带bizId 自由获取数据
   * @param {*} url
   * @param {*} map
   */
  @action async postByUrl(url, map = {}) {
    this._setBizId(map)
    let d = await http.post(url, map)
    return d
  }
  /**
   * 带bizId 自由获取数据
   * @param {*} url
   * @param {*} map
   */
  @action async getByUrl(url, map = {}) {
    this._setBizId(map)
    let d = await http.get(url, map)
    return d
  }

  //以下为业务的下拉框
  @observable countryList = []
  @action async getCountryList() {
    return
    let map = { filter: {} }
    await http.post(`/api/CountryList`, map, {}).then((d) => {
      if (d && d.res && d.res.length > 0) {
        d.res.map((v) => {
          v.value = v.countryid
          v.name = v.countryname
        })
        this.countryList = d.res
      }
    })
  }

  @observable giftList = []
  @action async getGiftList(filter) {
    let map = { filter: filter, pageData: { pageSize: 100, page: 1, order: 'giftid' } }
    await http.post(`/api/GiftList`, map, {}).then((d) => {
      if (d && d.res && d.res.length > 0) {
        d.res.map((v) => {
          v.value = v.giftid
          v.name = 'id:' + v.giftid + '|' + v.zh + '|钻石' + v.diamond / 100
          v.gold = v.gold
          v.diamond = v.diamond
        })
        this.giftList = d.res
      }
    })
  }

  @observable medalKeyList = []
  @action async getMedalKeyList(filter) {
    let map = { filter: filter, pageData: { pageSize: 999, page: 1 } }
    await http.post(`/api/medal/list`, map, {}).then((d) => {
      if (d && d.res && d.res.length > 0) {
        d.res.map((v) => {
          v.value = v.MedalKey
          v.name = v.NameZh + '|' + v.MedalKey
        })
        this.medalKeyList = d.res
      }
    })
  }

  @observable horseList = []
  @action async getHorseList(filter) {
    let map = { filter: filter, pageData: { pageSize: 100, page: 1 } }
    await http.post(`/api/HorseList`, map, {}).then((d) => {
      if (d && d.res && d.res.length > 0) {
        d.res.map((v) => {
          v.value = v.horseid
          v.name = 'id:' + v.horseid + '|' + v.zh
          v.gold = v.gold
        })
        this.horseList = d.res
      }
    })
  }

  @observable headList = []
  @action async getHeadList(filter) {
    let map = { filter: filter, pageData: { pageSize: 100, page: 1 } }
    await http.post(`/api/HeadList`, map, {}).then((d) => {
      if (d && d.res && d.res.length > 0) {
        d.res.map((v) => {
          v.value = v.headid
          v.name = 'id:' + v.headid + '|' + v.zh
          v.gold = v.gold
        })
        this.headList = d.res
      }
    })
  }

  @observable backgroundList = []
  @action async getBackgroundList(filter) {
    let map = { filter: filter, pageData: { pageSize: 100, page: 1 } }
    await http.post(`/api/AdminBackgroundList`, map, {}).then((d) => {
      if (d && d.res && d.res.length > 0) {
        d.res.map((v) => {
          v.value = v.backgroundid
          v.name = 'id:' + v.backgroundid + '|' + v.zh
          v.gold = v.gold
        })
        this.backgroundList = d.res
      }
    })
  }

  @observable nobilityList = []
  @action async getNobilityList(filter) {
    let map = {}
    await http.post(`/api/nobility/listall`, map, {}).then((d) => {
      if (d && d.res && d.res.length > 0) {
        d.res.map((v) => {
          v.value = v.id
          v.name = v.nobilityName + ' ' + v.durationDays + '天'
        })
        this.nobilityList = d.res
      }
    })
  }

  @observable packList = []
  @action async getPackList(filter) {
    let map = { filter: filter }
    await http.post(`/api/PackList`, map, {}).then((d) => {
      if (d && d.res && d.res.length > 0) {
        d.res.map((v) => {
          v.value = v.packGiftId
          v.name = 'id:' + v.packGiftId + '|' + v.name
          v.gold = v.gold
        })
        this.packList = d.res
      }
    })
  }

  @observable lightList = []
  @action async getLightList(filter) {
    let map = { filter: filter, pageData: { pageSize: 9999 } }
    await http.post(`/api/LightList`, map, {}).then((d) => {
      if (d && d.res && d.res.length > 0) {
        d.res.map((v) => {
          v.value = v.lightId
          v.name = 'id:' + v.lightId + '|' + v.name
        })
        this.lightList = d.res
      }
    })
  }

  @observable giftNewYearList = []
  @action async getGiftNewYearList() {
    let map = { filter: {} }
    await http.post(`/api/NewYearActivityList`, map, {}).then((d) => {
      if (d && d.res && d.res.length > 0) {
        this.giftNewYearList = d.res
      }
    })
  }

  @observable chargeuser = []
  @action async getChargeuser() {
    let map = {}
    console.log(333)
    await http.post(`/api/AdminUserList`, map, {}).then((d) => {
      if (d && d.res && d.res.length > 0) {
        d.res.map((v) => {
          v.value = v.id
          v.name = v.nickname
        })
        this.chargeuser = d.res
      }
    })
  }

  @observable medalList = []
  @action async getMedalList() {
    let map = { filter: {}, pageData: { page: 1, pageSize: 9999 } }
    await http.post(`/api/medal/list`, map, {}).then((d) => {
      if (d && d.res && d.res.length > 0) {
        d.res.map((v) => {
          v.value = v.Id
          v.name = 'id:' + v.Id + '|' + v.NameZh
        })
        this.medalList = d.res
      }
    })
  }

  @observable stateList = [
    { value: 0, name: '未知' },
    { value: 1, name: '是' },
    { value: 2, name: '否' }
  ]

  @observable state5List = [
    { value: 0, name: '全部' },
    { value: 1, name: '是' },
    { value: 2, name: '否' }
  ]

  @observable state4List = [
    { value: 0, name: '未知' },
    { value: 1, name: '可用' },
    { value: 2, name: '不可用' }
  ]

  @observable state2List = [
    { value: 0, name: '未知' },
    { value: 1, name: '有效' },
    { value: 2, name: '下架' }
  ]

  @observable stateMedal = [
    { value: 0, name: '未知' },
    { value: 1, name: '在勋章墙点击进去显示' },
    { value: 2, name: '在勋章墙点击进去不显示' },
    { value: 3, name: '在勋章墙点击进去不显示' }
  ]

  @observable stateMedalCell = [
    { value: 0, name: '未知' },
    { value: 1, name: '在勋章墙显示' },
    { value: 2, name: '在勋章墙不显示' }
  ]


  @observable state3List = [
    { value: 0, name: '否' },
    { value: 1, name: '是' }
  ]

  @observable medalStatus = [
    { value: 0, name: '未知' },
    { value: 1, name: '上架' },
    { value: 2, name: '下架' },
    { value: 3, name: '隐藏' }
  ]


  @observable coverList = [
    { value: false, name: '否' },
    { value: true, name: '是' }
  ]

  @observable dtypeList = [
    { value: 3, name: '用户充值(计入活动)' },
    { value: 34, name: '活动奖励' },
    { value: 37, name: '代理充值' },
    { value: 38, name: '内部测试' },
    { value: 39, name: '用户奖励' },
    { value: 11, name: '其他' }
  ]

  @observable medalType = [
    { value: 2, name: '活动勋章' },
    { value: 1, name: '成就勋章' }
  ]

  @observable modeList = [
    { value: 1, name: '任务模式' },
    { value: 2, name: '条件模式(无进度条)' }
  ]

  @observable stypeList = [
    { value: 0, name: '未知' },
    { value: 1, name: '每日注册' },
    { value: 2, name: '累计注册' },
    { value: 3, name: '每日充值' },
    { value: 4, name: '累计充值' },
    { value: 5, name: '日活' },
    { value: 6, name: '2日留存' },
    { value: 7, name: '金币消耗' },
    { value: 8, name: '金币增加' },
    { value: 9, name: '钻石增加' },
    { value: 10, name: '钻石消耗' }
  ]

  @observable rtypeList = [
    { value: 0, name: '其他' },
    { value: 1, name: '骚扰' },
    { value: 2, name: '涉黄' },
    { value: 3, name: '诈骗' },
    { value: 4, name: '垃圾信息' },
    { value: 5, name: '其他' }
  ]

  @observable customType = [
    { value: 0, name: '非定制' },
    { value: 1, name: '定制情侣' }
  ]

  @observable rewardStatus2 = [
    { value: -1, name: '全部' },
    { value: 1, name: '未达标' },
    { value: 2, name: '审核中' },
    { value: 3, name: '已发放' },
    { value: 4, name: '已拒绝' },
  ]

  @observable rewardStatus = [
    { value: 3, name: '同意' },
    { value: 4, name: '拒绝' }
  ]

  @observable itemType = [
    { value: 0, name: '座驾(默认)' },
    { value: 1, name: '头饰' },
    { value: 2, name: '礼物' },
    { value: 5, name: '背景' },
    { value: 6, name: '爵位' },
    { value: 4, name: '勋章' },
    { value: 3, name: '金币' },
  ]

  @observable utypeAddList = [
    { value: 5, name: '金币' },
    { value: 6, name: '钻石' }
  ]

  @observable gifttype = [
    { value: 0, name: '无(默认)' },
    { value: 1, name: '房间动画' },
    { value: 2, name: '全屏动画' }
  ]

  @observable langList = [
    { value: 1, name: '阿拉伯语' },
    { value: 2, name: '英语' },
    { value: 3, name: '中文' },
    { value: 0, name: '未知' }
  ]

  @observable langList2 = [
    { value: 'zh', name: '中文' },
    { value: 'en', name: '英语' },
    { value: 'ar', name: '阿拉伯语' },
    { value: 'tr', name: '土耳其' }
  ]

  @observable ltypeList = [
    { value: 0, name: '无(默认)' },
    { value: 1, name: '打开app页面' },
    { value: 2, name: '打开网页' },
    { value: 3, name: '发起请求' }
  ]

  @observable ltypeListN = [
    { value: 0, name: '无(默认)' },
    { value: 1, name: '打开房间' },
    { value: 2, name: '打开个人主页' },
    { value: 3, name: '打开网页(只填路径，不填域名)' },
    { value: 4, name: '打开钱包金币' },
    { value: 5, name: '打开钱包钻石' }
  ]

  @observable ltypeListN2 = [
    { value: -1, name: '无跳转' },
    { value: 1, name: '打开房间' },
    { value: 3, name: '打开H5链接' },
    { value: 4, name: '打开充值页' },
    { value: 5, name: '打开钱包钻石' },
    { value: 6, name: '打开首页' }
  ]

  @observable osList = [
    { value: 0, name: '无' },
    { value: 1, name: '全平台' },
    { value: 2, name: 'ios' },
    { value: 3, name: '安卓' }
  ]

  @observable osType = [
    { value: 0, name: '全平台' },
    { value: 1, name: 'ios' },
    { value: 2, name: '安卓' }
  ]

  @observable osType2 = [
    { value: 0, name: '指定用户' },
    { value: 1, name: 'ios' },
    { value: 2, name: '安卓' },
    { value: 3, name: '全部' }
  ]

  @observable reminderType = [
    { value: 1, name: '每日提醒（每日第一次打开app提醒' },
    { value: 2, name: '每次提醒（每次打开app提醒' },
    { value: 3, name: '首次提醒 （第一次打开app提醒，只提醒一次' }
  ]

  @observable statusType = [
    { value: 1, name: '启用' },
    { value: 2, name: '停用' }
  ]

  @observable status3Type = [
    { value: 1, name: '申请' },
    { value: 2, name: '同意' },
    { value: 3, name: '拒绝' }
  ]

  @observable utypeList = [
    { value: 0, name: '' },
    { value: 1, name: '总财富值' },
    { value: 2, name: '总魅力值' },
    { value: 3, name: '粉丝数' },
    { value: 4, name: '关注他人的数量' },
    { value: 5, name: '金币' },
    { value: 6, name: '钻石' },
    { value: 7, name: '总访客数量' },
    { value: 8, name: '7日财富值' },
    { value: 9, name: '7日魅力值' },
    { value: 10, name: '上麦分钟数' },
    { value: 11, name: '送出礼物个数' },
    { value: 12, name: '首次充值' },
    { value: 13, name: '分享记录' }
  ]

  @observable utypeList2 = [
    { value: 0, name: '' },
    { value: 1, name: '总财富值' },
    { value: 2, name: '总魅力值' },
    { value: 3, name: '粉丝数' },
    { value: 4, name: '关注他人的数量' },
    { value: 5, name: '金币' },
    { value: 6, name: '钻石' },
    { value: 7, name: '总访客数量' },
    { value: 8, name: '7日财富值' },
    { value: 9, name: '7日魅力值' },
    { value: 13, name: '分享记录' }
  ]

  @observable forbidType = [
    { value: 3, name: '封用户Id' },
    { value: 1, name: '封IP' },
    { value: 2, name: '封Mac' }
  ]

  @observable otypeList = [
    { value: 0, name: '所有' },
    { value: 1, name: 'ios' },
    { value: 2, name: '安卓' },
    { value: 3, name: '线下' },
    { value: 4, name: '代理充值' },
    { value: 5, name: '朋友充值' }
  ]

  @observable firstType = [
    { value: 0, name: '所有' },
    { value: 1, name: '首冲' },
    { value: 2, name: '首次大额' },
    { value: 3, name: '首冲+首次大额' }
  ]

  @observable bgstateList = [
    { value: 0, name: '未知' },
    { value: 1, name: '审核中' },
    { value: 2, name: '通过' },
    { value: 3, name: '驳回' }
  ]

  @observable duidStateList = [
    { value: 0, name: '未知' },
    { value: 1, name: '通过' },
    { value: 2, name: '审核中' },
    { value: 3, name: '驳回' }
  ]

  @observable taskStatusList = [
    { value: 0, name: '' },
    { value: 1, name: '进行中' },
    { value: 2, name: '已完成' },
    { value: 3, name: '删除' }
  ]

  @observable forbidTsList = [
    { value: 0, name: '' },
    { value: 3600, name: '1 hour' },
    { value: 21600, name: '6 hours' },
    { value: 86400, name: '1 day' },
    { value: 604800, name: '7 days' },
    { value: 2592000, name: '1 month' },
    { value: 31536000, name: '1 year' },
    { value: 315360000, name: '10 years' },
    { value: -1, name: '解除' }
  ]

  @observable actTagList = [
    { value: 0, name: '没设置' },
    { value: 5, name: '骑士红队礼物' },
    { value: 6, name: '骑士蓝队礼物' },
    { value: 9, name: '阿曼国家日礼物' },
    { value: 10, name: '阿联酋国家日礼物' },
    { value: 11, name: '巴林卡塔尔国家日礼物' },
    { value: 12, name: '元旦礼物' },
    { value: 13, name: '印度礼物' },
  ]

  @observable notinPkCpList = [
    { value: 0, name: '记录(周星礼物选记录，到时间自动不记录)' },
    { value: 1, name: '不记录(周星礼物此选项无效，非周星礼物还必须选 活动结束时间)' }
  ]

  @observable catList = [
    { value: 0, name: '金币' },
    { value: 1, name: '坐骑' },
    { value: 2, name: '头饰' },
    { value: 3, name: '主题' },
    { value: 4, name: '特殊坐骑' },
    { value: 5, name: '特殊头饰' },
    { value: 6, name: '特殊主题' }
  ]

  @observable noticeList = [
    { value: 0, name: '不通知' },
    { value: 1, name: '通知' }
  ]

  @observable boxidList = [
    { value: 71, name: '宝箱(发10个)' },
    { value: 72, name: '红包(发5个)' }
  ]

  @observable allCountryList = [
    { value: 0, name: '未设置' },
    { value: 101, name: 'Afghanistan' },
    { value: 102, name: 'Algeria' },
    { value: 103, name: 'Australia' },
    { value: 104, name: 'Austria' },
    { value: 105, name: 'Bahrain' },
    { value: 106, name: 'Bangladesh' },
    { value: 107, name: 'Canada' },
    { value: 108, name: 'China' },
    { value: 109, name: 'Egypt' },
    { value: 110, name: 'Ethiopia' },
    { value: 111, name: 'France' },
    { value: 112, name: 'Germany' },
    { value: 113, name: 'India' },
    { value: 114, name: 'Indonesia' },
    { value: 115, name: 'Iran' },
    { value: 116, name: 'Iraq' },
    { value: 117, name: 'Italy' },
    { value: 118, name: 'Japan' },
    { value: 119, name: 'Jordan' },
    { value: 120, name: 'KSA' },
    { value: 121, name: 'Kuwait' },
    { value: 122, name: 'Lebanon' },
    { value: 123, name: 'Libya' },
    { value: 124, name: 'Malaysia' },
    { value: 125, name: 'Morocco' },
    { value: 126, name: 'Netherlands' },
    { value: 127, name: 'Oman' },
    { value: 128, name: 'Pakistan' },
    { value: 129, name: 'Palestine' },
    { value: 130, name: 'Philippines' },
    { value: 131, name: 'Qatar' },
    { value: 132, name: 'Russia' },
    { value: 133, name: 'Spain' },
    { value: 134, name: 'Sudan' },
    { value: 135, name: 'Switzerland' },
    { value: 136, name: 'Syria' },
    { value: 137, name: 'Tunisia' },
    { value: 138, name: 'Turkey' },
    { value: 139, name: 'U.A.E' },
    { value: 140, name: 'UK' },
    { value: 141, name: 'Ukraine' },
    { value: 142, name: 'USA' },
    { value: 143, name: 'Yemen' }
  ]

  @observable chargeuserAdmin = []
  @action async getChargeuserAdmin() {
    let map = { filter: { power: 2 } }
    console.log(4444)
    await http.post(`/api/AdminUserList`, map, {}).then((d) => {
      if (d && d.res && d.res.length > 0) {
        d.res.map((v) => {
          v.value = v.id
          v.name = (v.remark && v.remark != '' ? v.remark + '(' + v.nickname + ')' : v.nickname)
        })
        this.chargeuserAdmin = d.res
      }
    })
  }

  @observable pushStatus = [
    { value: -2, name: '已删除' },
    { value: -1, name: '拒绝' },
    { value: 1, name: '正常' },
    { value: 2, name: '审核中' },
    { value: 3, name: '审核通过' },
    { value: 4, name: '发布完成' }
  ]

  @observable pushTaskType = [
    { value: 1, name: '推送' },
    { value: 2, name: '消息' },
    { value: 3, name: '消息+推送' }
  ]

  @observable deliveryTimeTs = [
    { value: 0, name: '立即发送' },
    { value: 1, name: '定时发送' }
  ]

  @observable msgStyle = [
    { value: 1, name: '公告' },
    { value: 2, name: '系统消息' }
  ]

  @observable actStatus = [
    { value: 1, name: '审核中' },
    { value: 2, name: '即将开始' },
    { value: 3, name: '进行中' },
    { value: 4, name: '已结束' },
    { value: 5, name: '已取消' },
    { value: 6, name: '审核不通过' }
  ]

  @observable actStatus2 = [
    { value: 2, name: '通过' },
    { value: 6, name: '不通过' }
  ]

  @observable OuterTeamType = [
    { value: 1, name: '国家管理员' },
    { value: 2, name: '活动小组' },
    { value: 3, name: '客服房间' },
    { value: 4, name: '主题房间' },
    { value: 5, name: '迎新房间' }
  ]

  @observable OuterTeamSettleType = [
    { value: 1, name: '周结(北京时间周三下午3点发放)' },
    { value: 2, name: '日结(北京时间每天下午3点发放)' }
  ]

  @observable OuterTeamStatus = [
    { value: 1, name: '启用' },
    { value: 2, name: '停用' },
    { value: 3, name: '删除' }
  ]

  @observable OuterTeamStatus3 = [
    { value: 1, name: '启用' },
    { value: 2, name: '停用' }
  ]

  @observable isInvalid = [
    { value: 1, name: '无效' },
    { value: 2, name: '有效' }
  ]

  @observable OuterTeamStatus2 = [
    { value: 1, name: '启用(将会正常给团队成员发放薪资)' },
    { value: 2, name: '停用(不会给团队成员发放薪资)' }
  ]

  @observable questionType = [
    { value: 1, name: 'APP问题' },
    { value: 2, name: '建议' },
    { value: 3, name: '充值' },
    { value: 4, name: '其他' }
  ]

  @observable fType = [
    { value: 1, name: '常见问题' },
    { value: 2, name: '房间和成员' },
    { value: 3, name: '账号和设置' },
    { value: 4, name: '其他问题' }
  ]

  @observable langType = [
    { value: 'zh', name: '中文' },
    { value: 'en', name: '英文' },
    { value: 'ar', name: '阿拉伯语' },
    { value: 'tr', name: '土耳其语' }
  ]

  @observable osStr = [
    { value: '', name: '全平台' },
    { value: 'ios', name: 'ios' },
    { value: 'android', name: '安卓' }
  ]

  @observable giftCategory = [
    { value: 1, name: '礼物' },
    { value: 2, name: '国家' },
    { value: 3, name: '专属' }
  ]

  @observable isRepliedType = [
    { value: 1, name: '已经回复' },
    { value: 2, name: '未回复' }
  ]

  @observable taskTypeList = [
    { value: 1, name: '服务端' },
    { value: 2, name: 'H5' }
  ]

  @observable outTeamMember = {}
  @action async getOutTeamMember(outerTeamId) {
    await http.post(`/api/admin/outerteam/getOuterTeam`, { "outerTeamId": outerTeamId }, {}).then((d) => {
      if (d && d.res) {
        if (d.res.outerTeamMemberList == null) {
          d.res.outerTeamMemberList = []
        }
        this.outTeamMember = d.res
        return
      }
      this.outTeamMember = { outerTeam: {}, outerTeamMemberList: [] }
    })
  }

  @observable translationtaskList = []
  @action async getTranslationtaskList() {
    await http.post(`/api/admin/translationtask/translationtaskList`, {}, {}).then((d) => {
      if (d.res.list && d.res.list != null && d.res.list.length > 0) {
        for (let i = 0; i < d.res.list.length; i++) {
          d.res.list[i].value = d.res.list[i].id
        }
        this.translationtaskList = d.res.list
      }
    })
  }
}



// WEBPACK FOOTER //
// ./store/crud.js